import React, { useRef, useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import POSBascula from '../../recursos/Bascula-Rhino.png';
import impresora from '../../recursos/Impresora-Xprinter.png';
import lector from '../../recursos/Lector-Qr.png';
import logoPlay from '../../recursos/Google-play.png';
import logoWindows from '../../recursos/Windows.png';
import logoPos from '../../recursos/Pos Logo_Bco.png';

// Hook para detectar si un elemento está visible en pantalla
function useOnScreen(ref, rootMargin = '0px') {
    const [isIntersecting, setIntersecting] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                setIntersecting(entry.isIntersecting);
            },
            { rootMargin }
        );
        if (ref.current) {
            observer.observe(ref.current);
        }
        return () => {
            if (ref.current) observer.unobserve(ref.current);
        };
    }, [ref, rootMargin]);

    return isIntersecting;
}

const containerVariants = {
    hidden: {},
    visible: {
        transition: {
            staggerChildren: 0.3,
        }
    }
};

const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.7, ease: "easeOut" } }
};

const Accesorios = () => {
    const panelRef = useRef(null);
    const isVisible = useOnScreen(panelRef, '-100px');

    const [hasAnimated, setHasAnimated] = useState(false);

    useEffect(() => {
        if (isVisible && !hasAnimated) {
            setHasAnimated(true);
        }
    }, [isVisible, hasAnimated]);

    return (
        <section
            ref={panelRef}
            style={{
                position: 'relative',
                display: 'flex',
                flexDirection: 'column',
                minHeight: 'auto',
                height: 'auto',
                width: '100%',
                backgroundImage: `url('/Fondo-Accesorios.png')`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                boxSizing: 'border-box',
                overflowX: 'hidden',
                overflowY: 'auto'
            }}
        >
            <div
                style={{
                    width: '100%',
                    maxWidth: '1200px',
                    margin: '0 auto',
                    display: 'flex',
                    flexDirection: 'column',
                    flexGrow: 1,
                    padding: '2rem 1rem',
                }}
            >
                <AnimatePresence>
                    {hasAnimated && (
                        <motion.div
                            variants={containerVariants}
                            initial="hidden"
                            animate="visible"
                            exit="hidden"
                            style={{ width: '100%', textAlign: 'center', padding: '0 20px', marginBottom: '3rem' }}
                        >
                            <motion.h1
                                variants={itemVariants}
                                style={{
                                    fontSize: 'clamp(1.8rem, 5vw, 2.5rem)',
                                    fontWeight: 'bold',
                                    color: '#1c4e84',
                                    margin: 0,
                                    lineHeight: '1.3',
                                }}
                            >
                                Optimiza tu operación{' '}
                                <span style={{ display: 'block' }}>con accesorios compatibles</span>
                            </motion.h1>

                            {/* Báscula Rhino */}
                            <motion.div
                                variants={itemVariants}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '2rem',
                                    flexWrap: 'wrap',
                                    marginTop: '3rem'
                                }}
                            >
                                <div style={{ flex: '1 1 200px', display: 'flex', justifyContent: 'center', minWidth: '200px' }}>
                                    <img
                                        src={POSBascula}
                                        alt="Báscula Rhino"
                                        style={{
                                            width: '100%',
                                            maxWidth: '160px',
                                            height: 'auto',
                                            borderRadius: '10px',
                                            objectFit: 'contain',
                                        }}
                                    />
                                </div>
                                <div style={{ flex: '2 1 300px', minWidth: '250px' }}>
                                    <h3 style={{ fontSize: 'clamp(1.1rem, 1.5vw, 1.3rem)', color: 'black', marginBottom: '1rem', fontWeight: 'bold', textAlign: 'left' }}>
                                        Báscula Rhino
                                    </h3>
                                    <p style={{ fontSize: 'clamp(0.9rem, 1.1vw, 1.1rem)', lineHeight: '1.6', color: '#333', textAlign: 'left' }}>
                                        Integra tu Báscula Rhino al POS Empatica para registrar automáticamente el peso de productos en cada venta, agilizando el cobro y reduciendo errores manuales.
                                    </p>
                                </div>
                            </motion.div>

                            {/* Impresora */}
                            <motion.div
                                variants={itemVariants}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '2rem',
                                    flexWrap: 'wrap-reverse',
                                    marginTop: '3rem'
                                }}
                            >
                                <div style={{ flex: '2 1 300px', minWidth: '250px' }}>
                                    <h3 style={{ fontSize: 'clamp(1.1rem, 1.5vw, 1.3rem)', color: 'black', marginBottom: '1rem', fontWeight: 'bold', textAlign: 'left' }}>
                                        Impresora Xprinter 80C
                                    </h3>
                                    <p style={{ fontSize: 'clamp(0.9rem, 1.1vw, 1.1rem)', lineHeight: '1.6', color: '#333', textAlign: 'left' }}>
                                        La impresora Xprinter 80C permite imprimir tickets y códigos QR para pagos con Quickpaymini, conectándose de forma inalámbrica vía Bluetooth o WiFi, o mediante cable USB en la versión de escritorio.
                                    </p>
                                </div>
                                <div style={{ flex: '1 1 200px', display: 'flex', justifyContent: 'center', minWidth: '200px' }}>
                                    <img
                                        src={impresora}
                                        alt="Impresora Xprinter"
                                        style={{
                                            width: '100%',
                                            maxWidth: '160px',
                                            height: 'auto',
                                            borderRadius: '10px',
                                            objectFit: 'contain',
                                        }}
                                    />
                                </div>
                            </motion.div>

                            {/* Lector */}
                            <motion.div
                                variants={itemVariants}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '2rem',
                                    flexWrap: 'wrap',
                                    marginTop: '3rem'
                                }}
                            >
                                <div style={{ flex: '1 1 200px', display: 'flex', justifyContent: 'center', minWidth: '200px' }}>
                                    <img
                                        src={lector}
                                        alt="Lector QR"
                                        style={{
                                            width: '100%',
                                            maxWidth: '160px',
                                            height: 'auto',
                                            borderRadius: '10px',
                                            objectFit: 'contain',
                                        }}
                                    />
                                </div>
                                <div style={{ flex: '2 1 300px', minWidth: '250px' }}>
                                    <h3 style={{ fontSize: 'clamp(1.1rem, 1.5vw, 1.3rem)', color: 'black', marginBottom: '1rem', fontWeight: 'bold', textAlign: 'left'}}>
                                        Lector Externo de QR
                                    </h3>
                                    <p style={{ fontSize: 'clamp(0.9rem, 1.1vw, 1.1rem)', lineHeight: '1.6', color: '#333', textAlign: 'left' }}>
                                        Optimiza aún más tu operación conectando un lector externo de códigos QR, ideal para negocios de alto volumen que requieren una lectura rápida y continua. (Quickpaymini ya cuenta con uno integrado).
                                    </p>
                                </div>
                            </motion.div>
                        </motion.div>
                    )}
                </AnimatePresence>
            </div>

            <div
                style={{
                    background: 'linear-gradient(to right, #28a7de, #1c4e84)',
                    padding: '1rem 0',
                    marginTop: 'auto',
                }}
            >
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        gap: '3rem',
                        flexWrap: 'wrap',
                        maxWidth: '1200px',
                        margin: '0 auto',
                        padding: '0 1rem',
                    }}
                >
                    <img src={logoPos} alt="POS Empatica" style={{ height: '45px' }} />
                    <img src={logoPlay} alt="Google Play" style={{ height: '45px' }} />
                    <img src={logoWindows} alt="Windows" style={{ height: '45px' }} />
                </div>
            </div>
        </section>
    );
};

export default Accesorios;
